<h2 class="popup-heading" mat-dialog-title>Start Cron Job</h2>
<div class="content">
    <span>
        This tool allows you to manually trigger the listeners billing process instantly,
        without waiting for the scheduled <strong>Cron Job</strong>. Use it to test or process charges on demand.
    </span>
    <mat-dialog-actions class="custom-dialog-actions" align="end">
        <button class="cancel-popup" mat-stroked-button mat-dialog-close (click)="close()">Cancel</button>
        <button class="popup-save" mat-flat-button
            [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" type="submit"
            (click)="setToCronJob()" [disabled]="processing">
            <mat-icon *ngIf="processing">
                <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
            </mat-icon>
            Run Cron Job Now
        </button>
    </mat-dialog-actions>